module.exports = __webpack_public_path__ + "89408fa1dc6889a5a53399f83d6fafda.jpg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/pap_testimonial-3-author.jpg
// module id = 3073
// module chunks = 2